<div class="dealer-search-notifications">
  <p ox-alert type="error" [show]="invalidSearch">
    <span aria-atomic="true" role="alert" [translate]="'locateDealer_error_invalidZipOrCityState'"></span>
  </p>

  <p ox-alert type="error" [show]="serverError">
    <span aria-atomic="true" role="alert" [translate]="'locateDealer_error_serverError'"></span>
  </p>

  <p ox-alert type="error" [show]="dealersTooFar">
    <span aria-atomic="true" role="alert" [translate]="'locateDealer_error_dealersTooFar'"></span>
  </p>
</div>